<template>
    <transition name="slide-in">
      <ModalControl :is_visible="is_visible">
        <div class="flex flex-row items-center justify-between">
          <LabelControl :content="$t('mip011')" />
          <IconControl @click="closeModal" id="exit-black" :width="50" :height="50" />
        </div>
  
        <DatePickerControl class="mt-10" @update:date="handleDateUpdate" />
  
        <div class="flex w-full justify-center align-center text-center">
          <div class="flex flex-col justify-center align-center text-center w-full">
            <ButtonControl @click="submitBirthdate"
                :disabled="!selected_year || !selected_month || !selected_day"
                :button_loading="loading" class='w-full' :text="$t('btn008')" />
          </div>
        </div>
      </ModalControl>
    </transition>

    <!-- Update successful -->
    <transition name="slide-in">
        <ModalControl :is_visible="this.toggle_message">
            <div class="flex flex-col justify-center align-center items-center p-8">
                <img :src="getIcon('check')" class="mb-10">
                <LabelControl type="heading" class="text-grey-darkest font-bold text-5xl mb-8 text-center"
                    :content="$t('mip016')" />
                <div class="flex w-full text-center justify-center align-center items-center">
                    <ButtonControl :text="$t('btn014')" theme="success" @click="toggleMessage" />
                </div>
            </div>
        </ModalControl>
    </transition>

    <!-- Existing Session -->
    <transition name="slide-in">
        <ModalControl :is_visible="this.existing_session">
            <SessionTimeoutControl />
        </ModalControl>
    </transition>

    <!-- Privacy Policy -->
    <transition name="slide-in">
        <ModalControl :is_visible="this.toggle_privacy" is_scrollable is_table :overlay_enabled="false">
            <div class="flex flex-col justify-center pt-10 px-10">
              <LabelControl type="dynamic" class="text-grey-darkest font-bold text-6xl mb-8 uppercase text-center"
              content="Privacy Policy" />
                            
              <PrivacyPolicyControl/>

                <div class="flex flex-row justify-center align-center items-center w-full" style="gap: 3rem;">
                  <ButtonControl text="I Disagree" theme="error" @click="toggle_privacy = false" class="w-full"/>
                  <ButtonControl text="I Agree" class="px-8 mr-5 w-full" theme="success" @click="submitBirthdate" />
                </div>
            </div>
        </ModalControl>
    </transition>

  </template>
  
  <script>
  import ModalControl from '@/components/controls/ModalControl.vue';
  import LabelControl from '@/components/controls/LabelControl.vue';
  import IconControl from '@/components/controls/IconControl.vue';
  import DatePickerControl from '@/components/controls/DatePickerControl.vue';
  import ButtonControl from '@/components/controls/ButtonControl.vue';
  import SessionTimeoutControl from './SessionTimeoutControl.vue';
  import PrivacyPolicyControl from '@/components/controls/PrivacyPolicyControl.vue';
  import mixin from '@/mixins/controls.js';
  import user from '@/services/user';
  
  export default {
    name: 'BirthdayModal',
    inject: ['setLoading', 'setError'],
    emits: ['close', 'birthdate-updated'],
    mixins: [mixin],
    components: {
      ModalControl,
      LabelControl,
      IconControl,
      DatePickerControl,
      ButtonControl,
      SessionTimeoutControl,
      PrivacyPolicyControl,
    },
    props: {
      is_visible: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        selected_year: null,
        selected_month: null,
        selected_day: null,
        toggle_message: false,
        existing_session: false,
        toggle_privacy: false,
        loading: false,
        hash: "",
        uuid: "",
      };
    },
    mounted() {
        const state = this.$store.state.user;
        this.full_name = `${state.first_name} ${state.middle_name} ${state.last_name}`;
        this.phone_number = state.mobile;
        this.hash = state.hash;
        this.tin = state.tin;
        this.qr = state.qr;
        this.uuid = state.uuid;
        this.email = state.email;
        this.key = state.key;

        const enrollee = this.$store.state.pin_enrollment;
        this.enrollee_mobile = enrollee.mobile; 
        this.enrollee_email = enrollee.email;
        this.enrollee_name = enrollee.name;
        this.enrollee_uuid = enrollee.uuid;
        this.enrollee_hash = enrollee.hash;
    },
    methods: {
      handleDateUpdate({ year, month, day }) {
        this.selected_year = year;
        this.selected_month = month;
        this.selected_day = day;
      },
      submitBirthdate() {
        if (!this.selected_year || !this.selected_month || !this.selected_day) {
          console.error("Please select a valid birthdate.");
          return;
        }
        // console.log('Selected Year:', this.selected_year);
        // console.log('Selected Month:', this.selected_month);
        // console.log('Selected Day:', this.selected_day);
        this.setLoading(true);
        // this.loading = true;
        user.editBirthdate(
          this.hash,
          this.selected_month,
          this.selected_day,
          this.selected_year,
          this.key
        )
          .then(() => {
            // this.loading = false;
            this.setLoading(false);
            this.$store.commit('updateBirthdate', `${this.selected_year}-${this.selected_month}-${this.selected_day}`);
            this.$emit('birthdate-updated');
            this.showSuccess('Birthdate updated successfully!');
            this.closeModal();
            this.$router.push({name: 'member-info-page'});
          })
          .catch((error) => {
            if (error.response && error.response.status === 403) {
                this.closeModal();
              this.resetUserData();
              this.clearUserCookie();
              this.toggleExistingSessionModal();
              // this.loading = false;
              this.setLoading(false);

            }
            // this.loading = false;
            this.setLoading(false);

            this.closeModal();
            console.error("Error in editing birthdate:", error);
          });
      },
      closeModal() {
        this.$emit('close');
      },
      toggleMessage() {
            this.toggle_message = !this.toggle_message;
        },
    },
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>